export { default as GeneralHtmlSupport } from '@ckeditor/ckeditor5-html-support/src/generalhtmlsupport'

import { GeneralHtmlSupportConfig } from '@ckeditor/ckeditor5-html-support/src/generalhtmlsupportconfig'

declare module '@ckeditor/ckeditor5-core/src/editor/editorconfig' {
  interface EditorConfig {
    htmlSupport?: GeneralHtmlSupportConfig
  }
}
